import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class PasswordValidator {
    static complexity(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        const errors: ValidationErrors = {};

        if (value) {
            if (value.search(/(?=.*[\W_])/) < 0) {
                errors['special'] = true;
            }
            if (value.search(/[0-9]/g) < 0) {
                errors['numbers'] = true;
            }
            if (value.search(/^(?=.*[a-z])(?=.*[A-Z]).*$/) < 0) {
                errors['letters'] = true;
            }
            if (value.length < 10) {
                errors['size'] = true;
            }
        }

        return Object.keys(errors).length > 0 ? errors : null;
    }
    static mustBeEquals(control: AbstractControl): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }

        const form = control.parent as FormGroup;
        const newPassword = form.get('newPassword')?.value;
        const newPasswordConfirmation = form.get('newPasswordConfirmation')?.value;

        if (newPassword && newPasswordConfirmation && newPassword !== newPasswordConfirmation) {
            return { newPasswordConfirmation: true };
        }

        return null;
    }
}
